export const SOURCE_METRIC_SCHEMA_STORE_KEY = 'sourceMetricSchema';
export const SOURCE_METRIC_SCHEMA_SERVICE_KEY = 'sourceMetricSchema';
export const SOURCE_METRIC_SCHEMA_API_URL = '/api/v1/metric/schema/source/';
